import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { ComponentsModule } from '@components/components.module';
import { FormInstance } from '@models/global-forms';
import {
	EmptyComponent,
	UI_EMPTY_PRESET,
} from 'src/app/ui/empty/empty.component';
import { TestHooks } from './matter-package-preview.hooks';

@Component({
	selector: 'app-matter-package-preview',
	templateUrl: './matter-package-preview.component.html',
	imports: [CommonModule, ComponentsModule, EmptyComponent],
})
export class MatterPackagePreviewComponent {
	testHooks = TestHooks;
	UI_EMPTY_PRESET = UI_EMPTY_PRESET;
	hasNoContents_ = input<boolean>();
	docxPreviewDocId_ = input<string>();
	form_ = input<FormInstance>();
	uploadedDocPreviewSourcePath_ = input<string>();
}
